import { z } from 'zod';

export const RawSourceKind = z.enum(['pdf', 'image', 'text']);
export type RawSourceKind = z.infer<typeof RawSourceKind>;

export const RawSource = z.object({
  id: z.string(),
  kind: RawSourceKind,
  label: z.string(),
  text: z.string(),
  page_range: z.tuple([z.number(), z.number()]).optional(),
  mime_type: z.string().optional(),
  byte_size: z.number().optional(),
});
export type RawSource = z.infer<typeof RawSource>;

export function concatenateSources(sources: RawSource[]): string {
  return sources
    .map((s, i) => `=== SOURCE ${i + 1}: ${s.label} (${s.kind}) ===\n${s.text}`)
    .join('\n\n');
}
